<div class="border rounded-xl p-6 flex flex-col gap-1 border-gray-700 bg-(--p-surface-900)">
  <div class="flex items-center justify-between">
    <h2 class="text-gray-50 font-bold text-lg">
      {{ 'common.uploadProgress' | transloco }}
    </h2>

    <div class="flex items-center gap-4 w-48">
      <span class="text-gray-400 text-sm font-medium">{{
        completedCountMandatory() + '/' + totalCountMandatory()
      }}</span>
      <div class="h-2 w-full bg-gray-800 rounded-full overflow-hidden">
        <div
          class="h-full transition-all duration-500"
          [style.width.%]="percentage()"
          [ngClass]="progressBarClass()"
        ></div>
      </div>
    </div>
  </div>

  <p class="text-gray-500 text-sm">
    {{ 'provider.tenderWizard.rfq.upload.document.count' | transloco }}
  </p>
</div>
